import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SelectItem, Table } from 'primeng';
import { AccessUserInfo, LabResult, UserDetail, UserLocationFacility } from 'src/app/models';
import { CustomDatePipe } from 'src/app/pipes';
import { CustomDialogService,   LabRequisitionService, UserService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';
import { PreviewLabelComponent } from '../../request/preview-label/preview-label.component';
import { DatePipe } from '@angular/common';
import { EnumLabRange } from 'src/app/enum/water-lab/labRange';
import { LabRequestHistoryComponent } from '../../request/lab-request-history/lab-request-history.component';
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { Router } from '@angular/router';
import { WorkFlow } from "src/app/enum/water-lab/workFlow"
@Component({
  selector: 'bart-view-lab-results',
  templateUrl: './view-lab-results.component.html',
  styleUrls: ['./view-lab-results.component.scss'],
  providers : [ CustomDialogService,CustomDatePipe,DatePipe]
})
export class ViewLabResultsComponent implements OnInit {
  @Input() selectedFacilityMasterId : number= null;
  @Input() userLocationFacilities :UserLocationFacility []= [];
  @Input() labRequestID? :number=null;
  @Input() selectLabResultRow:LabResult[]=[];
  @Input() isFromLabrequeststPage:boolean=false;
  @Output() selectLabResultRowChange = new EventEmitter();
  @Input() isFromLabResultPage:boolean=false;
  // @Input() DateRange:string=null;
  // @Output() DateRangeChange = new EventEmitter();
  @ViewChild('dtLabResultTable', { static: false }) dtLabResultTable: Table;
  public ENUM_LAB_RANGE = EnumLabRange;
  facilityList: SelectItem[] = [];
  public userInfo: UserDetail;
  selectedFilter?:string=null
  labResultColumnHeader: any[];
  filteredLabResults: LabResult[] = [];
  filterOptions:SelectItem[]=[]
  workFlow:string
  facilityDisplayName:string;
  printPDF=false;
  isHeaderCheckBoxChecked: boolean;
  //
  startDate:string
  endDate:string;
  rows=10;
  colSpan=12;
  constructor
  (  
    public dialogService: CustomDialogService,
    private _loaderService: LoaderService,
    private _labRequisition: LabRequisitionService,
    private _datePipe : DatePipe,
    private _userService:UserService,
    private customDatePipe :CustomDatePipe,
    private router: Router
  ) 
  {
    this.userInfo = AccessUserInfo.getUserInfo();
    this.selectedFacilityMasterId= AccessUserInfo.getSelectedFacilityMasterId()
  }

  ngOnInit() {
    if(this.labRequestID)
    {
      this.rows=5;
      this.colSpan=10;
    }
    this.labResultColumnHeader = 
    [
      { field: 'LabRequisitionNumber', header: 'Requisition ID', display: 'table-cell', width:"9%"},
      { field: 'TestDisplayName', header: 'Test ID | Name', display: 'table-cell',width:"15%", expandedField:"TestDisplayName"},
      { field: 'EquipmentDisplayName', header: 'Model # | Serial # | Equipment ID ' ,width:"20%" },
      { field: 'LabResult', header: 'Result | Unit', display: 'table-cell',width:"10%" ,expandedField:"TestResult"},
      { field: 'LabRange', header: 'Range ' ,width:"9%",expandedField:"LabRange"},
      { field: 'LabComments', header: 'Lab Comments', display: 'table-cell' ,width:"19%",expandedField:"LabComments"},
      { field: 'Status', header: 'Status', display: 'table-cell', width:"8%",expandedField:"LabResultStatus"},
      { field: 'DrawDate', header: 'Draw Date', display: 'table-cell', width:"10%" },
    ];
    this.getFilterOptions();
    let labResultScreenName = this.isFromLabResultPage?ScreenName.LAB_RESULTS: ScreenName.LABREQUEST_HISTORY
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.FILTER,
      screenName:this.isFromLabrequeststPage?ScreenName.LABREQUEST: labResultScreenName,
      screenPath: location.pathname,
      key: "Filter_JSON",
      value: 
      JSON.stringify( { 
        selectedFacilityMasterId:this.selectedFacilityMasterId,
        selectedSearchBy:this.selectedFilter,
        selectedLabRequestID:this.labRequestID
      }
       )
       ,
       eventDescription:UserActionDescription.LAB_RESULTS_GRID_LOADED
    });
  }
    
  ngOnChanges(changes: SimpleChanges) 
  {
    let currentValue:any;
    let previousValue:any;
    if(changes && changes.selectedFacilityMasterId)
    {
      previousValue=changes.selectedFacilityMasterId.previousValue
      currentValue=changes.selectedFacilityMasterId.currentValue
      if(previousValue!=currentValue)
      {
         this.facilityChanged();

                   //#region User Action Audit
            this._userService.logUserAction({
              userName: this.userInfo.userName,
              userAction: UserAction.FILTER,
              screenName: ScreenName.LAB_RESULTS,
              screenPath: location.pathname,
              // key: "FacilityMasterID",
              // value: this.selectedFacilityMasterId,
              key: "Filter_JSON",
              value: 
              JSON.stringify( { 
                selectedFacilityMasterID: this.selectedFacilityMasterId,
                selectedSearchBy:this.selectedFilter,
                selectedStartDate:this._datePipe.transform(this.startDate,"MM/dd/yyyy")  ,
                selectedEndDate:this._datePipe.transform(this.endDate,"MM/dd/yyyy"),
                selectedLabRequestID:this.labRequestID
              }
               )
               ,

              eventDescription:UserActionDescription.LAB_RESULTS_FACILITY_CHANGED
            });
            //#endregion
      }
    }
    
  }
  facilityChanged() 
  {
 
    this.startDate=null;
    this.endDate=null;
    this.selectedFilter="Past 90 days";
    AccessUserInfo.setSelectedFacilityMasterId(this.selectedFacilityMasterId.toString())
    this.facilityDisplayName=this.userLocationFacilities.find(x=>x.FacilityMasterID==this.selectedFacilityMasterId).FacilityDisplayName
    this.loadLabResults();
  }
  loadLabResults() {
    this.resetTable();
    this._loaderService.show()
    let getLabResultParam = {
      "GETLABRESULT": {
        FacilityMasterID: this.selectedFacilityMasterId,
        SearchBy:this.selectedFilter,
        StartDate:this._datePipe.transform(this.startDate,"MM/dd/yyyy")  ,
        EndDate:this._datePipe.transform(this.endDate,"MM/dd/yyyy"),
        LabRequestID:this.labRequestID
      },
    }
    this.filteredLabResults = [];
    this._labRequisition.getLabResults(JSON.stringify(getLabResultParam)).subscribe(data => {
      this.filteredLabResults = data.getLabResult;
      this.filteredLabResults.forEach(item => {
        item.LabProfileTests = JSON.parse(item.LabProfileTestsJson)
        item.DrawDate=this.customDatePipe.transform(item.DrawDate,"local","MM/dd/yyyy HH:mm");
        item.DrawDateSort=new Date (this.customDatePipe.transform(item.DrawDate,"local","MM/dd/yyyy HH:mm"));
      });
      this._loaderService.hide()
    },
      err => {
        this.filteredLabResults = [];
        this._loaderService.hide()
      });

  }
  onFilter(event)
  {
    this.resetTable(false);
  }
  resetTable(isTableReset:boolean=true)
  {
    if (this.dtLabResultTable && isTableReset) {
      this.dtLabResultTable.reset();
    }
    this.selectLabResultRow = [];
    this.selectLabResultRowChange.emit(this.selectLabResultRow);
    this.isHeaderCheckBoxChecked = false;
  }
  // openHistoryPopup(rowData:LabResult) {
  //   const ref = this.dialogService.open(LabResultHistoryComponent, {
  //     header: 'View History',
  //     width: '90%',
  //     styleClass:'lab-reult-history-model-popup',
  //     data: { rowData: rowData, userLocationFacilities:this.userLocationFacilities,selectedFacilityMasterId:this.selectedFacilityMasterId  }
  //   });

     openHistoryPopup(rowData:LabResult) {
      const ref = this.dialogService.open(LabRequestHistoryComponent, {
        header: 'Lab Request History',
        width: '90%',
        styleClass:'lab-request-history-model-popup',
        data: 
          { 
            labRequestId: rowData.LabRequestID, 
            facilityDisplayName:this.facilityDisplayName,
            selectedFacilityMasterId:this.selectedFacilityMasterId,
            userLocationFacilities:this.userLocationFacilities, 
            isFromLabResultPage:true ,
            startDate : this.selectedFilter == "Date Range" ? this.startDate : null,
            endDate : this.selectedFilter == "Date Range" ? this.endDate : null
          }
  
      });

     //#region User Action Audit
     this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.LAB_RESULTS,
      screenPath: location.pathname,
      key: "LabRequestID",
      value: rowData.LabRequestID,
      eventDescription:UserActionDescription.LAB_RESULTS_VIEW_HISTORY_ICON_CLICKED
    });
    //#endregion
    
  }
  redrawLabRequisition(rowData:LabResult)
  {
    const ref = this.dialogService.open(PreviewLabelComponent, {
      header: WorkFlow.HOME==rowData.WorkFlow?'Home Label Summary':'Label Summary',
      styleClass:"preview-label-summary-popup",
      data:
      {
        labRequisitionId:rowData.LabRequisitionID,
        labRequestId:rowData.LabRequestID,
        facilityMasterId:this.selectedFacilityMasterId,
        facilityDisplayName:this.facilityDisplayName,
        workFlow:rowData.WorkFlow,
        selectedRows:rowData,
        isReDraw:true
      }
    });
    ref.onClose.subscribe(ref => {
      // this.loadLabResults();
      if(ref && ref.result && !ref.isSuccess){
        this.router.navigate(["/WaterLab/ShippingManifest"]);
      }
    });

     //#region User Action Audit
     this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.LAB_RESULTS,
      screenPath: location.pathname,
      key: "LabRequisitionID",
      value: rowData.LabRequisitionID,
      eventDescription:UserActionDescription.LAB_RESULTS_REDRAW_CLICKED
    });
    //#endregion
  }
  getFilterOptions()
  {
    this.filterOptions=[
      {
        value:"All Result",label:"All Results"
      },
      {
        value:"Date Range",label:"Date Range"
      },
      {
        value:"Out of Range",label:"Out of Range"
      },
      {
        value:"Last 5 Results",label:"Last 5 Results"
      },
      {
        value:"Last 10 Results",label:"Last 10 Results"
      },
      {
        value:"Last 20 Results",label:"Last 20 Results"
      },
      {
        value:"Last 3 Years",label:"Last 3 Years"
      },
      {
        value:"Last 3 Months",label:"Last 3 Months"
      },
      {
        value:"Past 90 days",label:"Past 90 days"
      },
      {
        value:"Last 3 Days",label:"Last 3 Days"
      },
    ]
  }
  filterDropdownChanged()
  {
    if(this.selectedFilter=="Date Range")
    {
      return;
    }
    else
    {
      this.startDate=null;
      this.endDate=null;
    }
    this.loadLabResults();
    let labResultScrnName = this.isFromLabResultPage?ScreenName.LAB_RESULTS: ScreenName.LABREQUEST_HISTORY
    let labResultEventDescription = this.isFromLabResultPage?UserActionDescription.LAB_RESULTS_VIEW_RESULT_BY_CHANGED: UserActionDescription.LAB_RESULTS_LAB_REQUEST_HISTORY_VIEW_RESULT_BY_CHANGED;
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.FILTER,
      screenName: this.isFromLabrequeststPage?ScreenName.LABREQUEST: labResultScrnName,
      screenPath: location.pathname,
      // key: "SearchBy",
      // value: this.selectedFilter,
      key: "Filter_JSON",
      value: 
      JSON.stringify( { 
        selectedFacilityMasterId:this.selectedFacilityMasterId,
        selectedSearchBy:this.selectedFilter,
        selectedLabRequestID:this.labRequestID
      }
       )
       ,

      eventDescription:this.isFromLabrequeststPage?UserActionDescription.LAB_REQUEST_LAB_REQUEST_HISTORY_VIEW_RESULT_BY_CHANGED:labResultEventDescription
    });
    //#endregion

  }
  applyFilterButtonClicked()
  {
    // if(this.selectedFilter=="Date Range")
    // {
    //   this.DateRange=this.startDate+" - " +this.endDate
    //   this.DateRangeChange.emit(this.DateRange);
    // }
    this.loadLabResults();
     //#region User Action Audit
     let labResultScreenName = this.isFromLabResultPage? ScreenName.LAB_RESULTS:ScreenName.LABREQUEST_HISTORY
     let eventDescriptionLabResult =this.isFromLabResultPage? UserActionDescription.LAB_RESULTS_APPLY_CLICKED:UserActionDescription.LAB_RESULTS_LAB_REQUEST_HISTORY_APPLY_CLICKED
     this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.FILTER,
      screenName: labResultScreenName,
      screenPath: location.pathname,
      key: "Filter_JSON",
      value: 
      JSON.stringify( { 
        FacilityMasterID: this.selectedFacilityMasterId,
        SearchBy:this.selectedFilter,
        StartDate:this._datePipe.transform(this.startDate,"MM/dd/yyyy")  ,
        EndDate:this._datePipe.transform(this.endDate,"MM/dd/yyyy"),
        LabRequestID:this.labRequestID
      }
       )
       ,

      eventDescription:this.isFromLabrequeststPage?UserActionDescription.LAB_REQUEST_LAB_REQUEST_HISTORY_APPLY_CLICKED:eventDescriptionLabResult
    });
    //#endregion

  }
  printLabResultPDF()
  {
    this._loaderService.show();
    this.printPDF=true;
     //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction:UserAction.BUTTON_CLICKED,
      screenName:ScreenName.LAB_RESULTS,
      screenPath:location.pathname,
      key: "LabRequisitionID",
      value: this.selectLabResultRow.map(x => x.LabRequisitionID).join(","),
      eventDescription:UserActionDescription.LAB_RESULTS_PRINT_CLICKED
    }); 
    //#endregion
  }
  printPDFLoaded()
  {
    this.printPDF=false; 
    this._loaderService.hide();     
  }  

  headerCheckBoxChecked()
  {
    let pageOfItems = this.filteredLabResults ? this.filteredLabResults.slice(this.dtLabResultTable.first, (this.dtLabResultTable.first + this.dtLabResultTable.rows)) : [];
    if(this.dtLabResultTable.filteredValue)
    {
      pageOfItems=this.dtLabResultTable.filteredValue.slice(this.dtLabResultTable.first, (this.dtLabResultTable.first + this.dtLabResultTable.rows));
    }
    if (this.isHeaderCheckBoxChecked) 
    {
      this.selectLabResultRow = this.selectLabResultRow.concat(pageOfItems);
    }
    else 
    {
      this.selectLabResultRow = this.selectLabResultRow.filter(ar => !pageOfItems.find(rm => (rm.LabRequisitionID === ar.LabRequisitionID)))
    }
    this. rowSelectionChanged()
  }
  rowCheckBoxChecked()
  {
    this.manageCheckBoxSelection();
    this. rowSelectionChanged()
  }
  manageCheckBoxSelection() 
  {
    let pageOfItems = this.filteredLabResults ? this.filteredLabResults.slice(this.dtLabResultTable.first, (this.dtLabResultTable.first + this.dtLabResultTable.rows)) : [];
    if(this.dtLabResultTable.filteredValue)
    {
      pageOfItems=this.dtLabResultTable.filteredValue.slice(this.dtLabResultTable.first, (this.dtLabResultTable.first + this.dtLabResultTable.rows));
    }
    let activeObjA = pageOfItems
    let activeObjB = this.selectLabResultRow.filter(ar => activeObjA.find(rm => (rm.LabRequisitionID === ar.LabRequisitionID)))
    if (activeObjA.length == activeObjB.length && activeObjA.length > 0) 
    {
      this.isHeaderCheckBoxChecked = true;
    }
    else 
    {
      this.isHeaderCheckBoxChecked = false;
    }
  }

  paginate(event) 
  {
    this.manageCheckBoxSelection()
    let labResultEevantPageDesc = this.isFromLabResultPage? UserActionDescription.LAB_RESULTS_PAGE_NO_CLICKED:UserActionDescription.LAB_RESULTS_LAB_REQUEST_HISTORY_PAGE_NO_CLICKED;
     //#region User Action Audit
     this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.PAGE_CHANGED,
      screenName: this.isFromLabResultPage?ScreenName.LAB_RESULTS: ScreenName.LABREQUEST_HISTORY,
      screenPath: location.pathname,
      key: 'Selected_Page_No',
      value: (event.first / event.rows) + 1,
      eventDescription:this.isFromLabrequeststPage?UserActionDescription.LAB_REQUEST_LAB_REQUEST_HISTORY_PAGE_NO_CLICKED:labResultEevantPageDesc
    });
    //#endregion
    
  }
  sortColumn(event)
   {
    this.resetTable(false)
    //#region User Action Audit
    let labResultEevantDescription = this.isFromLabResultPage? UserActionDescription.LAB_RESULTS_COLUMN_SORT:UserActionDescription.LAB_RESULTS_LAB_REQUEST_HISTORY_COLUMN_SORT;
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.SORT,
      screenName: this.isFromLabResultPage?ScreenName.LAB_RESULTS: ScreenName.LABREQUEST_HISTORY,
      screenPath: location.pathname,
      key: event.field,
      value: event.order === 1 ? 'ASC' : 'DESC',
      eventDescription:this.isFromLabrequeststPage?UserActionDescription.LAB_REQUEST_LAB_REQUEST_HISTORY_COLUMN_SORT:labResultEevantDescription
    });
    //#endregion
  }

  rowSelectionChanged()
  {
    this.selectLabResultRowChange.emit(this.selectLabResultRow);
  }
}
